import { render, staticRenderFns } from "./architectureOrder.vue?vue&type=template&id=95b308e4"
import script from "./architectureOrder.vue?vue&type=script&lang=js"
export * from "./architectureOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports